export default __webpack_public_path__ + "static/media/inProgressCheckmark.a95269b8.svg";